let challenges = ['find_user', 'verify_email', 'passwd'];
let currentChallengeIndex = 0;

const successResponse = {
  "outcome": "success"
};

export default {
  getChallenge: () => fetch(challenges[currentChallengeIndex++ % challenges.length]),
  initChallenge: () => fetch({}),
  findUserChallenge: () => fetch(successResponse),
  verifyEmailChallenge: () => fetch(successResponse),
  passwdChallenge: () => fetch(successResponse)
};

const fetch = (mockData, time = process.env.VUE_APP_MOCKED_HTTP_DELAY) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData)
    }, time);
  });
};
